import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import axios from "axios";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store/configureStore";
import { initUser } from "./actions/userActions";
//import { API_TOKEN_NAME, LOGIN_PAGE_PATH, IS_ACTIVE, USER_ID} from './constants';
import "./css/style.css";
import "./css/VerticalCarousel.css";
import "./css/newstyle.css";
import "./css/dashboardstyle.css";
import "./css/responsive.css";
import "./css/bodypartcss/style.css";

//import './css/bodypartcss/devcustom.css';
//import './css/bodypartcss/custom.css';
//import servernode from '../server.js';
//import './assets/scss/app.scss';
//import './assets/css/topbar.css';
//import './assets/css/vertical.css';
//import './assets/css/custom.css';

let dynUrl;
let dynAdmUrl;
let dynUrlSms;

let host_name = window.location.hostname;

// if (host_name === "localhost") {
//   dynAdmUrl = process.env.REACT_APP_LOCAL_URL + "/unitedhospitalapi/api";
//   dynUrl = process.env.REACT_APP_STAGING_URL + "/unitedhospitalapi/api";
//   // dynUrl = 'http://localhost/reactjs/demoreactapibackend/api';
//   //dynUrl = 'https://cors-anywhere.herokuapp.com/http://45.64.132.130:3388/zab';
//   dynUrl = "http://45.64.132.149:3388/zab";
//   //dynUrl = 'https://cors-anywhere.herokuapp.com/http://45.64.132.149:3388/zab';
//   dynUrlSms = process.env.REACT_APP_LOCAL_URL + "/unitedhospitalapi/api";
// }

if (host_name === "localhost") {
  dynAdmUrl = process.env.REACT_APP_LOCAL_BACKEND_URL + "/api";
  dynUrl = process.env.REACT_APP_LOCAL_BACKEND_URL + "/api";
  dynUrlSms = process.env.REACT_APP_LOCAL_BACKEND_URL + "/api";
}

if (host_name === "etherstaging.com") {
  dynAdmUrl = process.env.REACT_APP_ETHER_BACKEND_URL + "/api";
  dynUrl = process.env.REACT_APP_ETHER_BACKEND_URL + "/api";
  dynUrlSms = process.env.REACT_APP_ETHER_BACKEND_URL + "/api";
}

if (host_name === "beta.uhlbd.com") {
  dynAdmUrl = process.env.REACT_APP_BETA_BACKEND_URL + "/api";
  dynUrl = process.env.REACT_APP_BETA_BACKEND_URL + "/api";
  dynUrlSms = process.env.REACT_APP_BETA_BACKEND_URL + "/api";
}

if (host_name === "uhlbd.com") {
  dynAdmUrl = process.env.REACT_APP_LIVE_BACKEND_URL + "/api";
  dynUrl = process.env.REACT_APP_LIVE_BACKEND_URL + "/api";
  dynUrlSms = process.env.REACT_APP_LIVE_BACKEND_URL + "/api";
}

export const scAxios = axios.create({
  baseURL: dynUrl,
});

export const scAxiosAdmin = axios.create({
  baseURL: dynAdmUrl,
});

export const scAxiosSMS = axios.create({
  baseURL: dynUrlSms,
});

export const thirdparty = axios.create({
  baseURL: dynAdmUrl,
});
const store = configureStore();
store.dispatch(initUser());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js